<!--
 * @Description: 申请发票
 * @Author:  wang.y
-->
<template>
  <Modal v-model="modelIndex" width="530" class="login-model" @on-cancel="close" @on-visible-change="clearForms" :footer-hide="true">
    <div class="container-wrapper">
      <div class="model-bg-wrapper">
        <img :src="static_img_url + 'pic/modal-bg-top.png?v=' + $store.state.imgVersion" />
        <!-- <img :src="static_img_url + 'pic/modal-bg-btm.png?v=' + $store.state.imgVersion" /> -->
      </div>
      <div class="container-content">
        <div class="container-top">
          <div class="container-title reset-form-title" v-if="language == 'zh'">{{orderItem.invoiceStatus == 0 ? '申请发票' : '查看发票信息'}}</div>
          <div class="container-title reset-form-title" v-else>{{orderItem.invoiceStatus == 0 ? 'Invoice' : 'View invoice'}}</div>
          <Form ref="apply-invoice" :label-width="74" label-position="left" :model="invoiceForm" :rules="ruleValidate" v-show="orderItem.invoiceStatus == 0">
            <FormItem :label="'发票金额' | dealLanguage('Amount')" class="lh20">
              <span>¥{{orderItem.paymentAmount}}</span>
            </FormItem>
            <FormItem :label="'发票类型' | dealLanguage('Invoice Type')" class="lh20">
              <span>{{'增值税电子普通发票' | dealLanguage('VAT electronic general invoice')}}</span>
            </FormItem>
            <FormItem :label="'抬头类型' | dealLanguage('Header Type')" class="lh30">
              <RadioGroup v-model="invoiceForm.headerType">
                <Radio :label="1">
                  <span>{{'个人' | dealLanguage('personal')}}</span>
                </Radio>
                <Radio :label="2">
                  <span>{{'单位' | dealLanguage('company')}}</span>
                </Radio>
              </RadioGroup>
            </FormItem>
            <FormItem prop="header" :label="'发票抬头' | dealLanguage('Invoice Title')">
              <Input type="text" v-model="invoiceForm.header" :placeholder="'请输入发票抬头' | dealLanguage('Please enter the invoice title')"></Input>
            </FormItem>
            <FormItem prop="uniformSocialCreditCode" :label="'单位税号' | dealLanguage('Unit tax number')" v-if="invoiceForm.headerType == 2">
              <Input type="text" v-model="invoiceForm.uniformSocialCreditCode" :placeholder="'请输入单位税号（企业必填）' | dealLanguage('Please enter your company tax number (required for enterprises)')"></Input>
            </FormItem>
            <FormItem prop="email" :label="'电子邮箱' | dealLanguage('Email')">
              <Input type="text" v-model="invoiceForm.email" :placeholder="'请输入电子邮箱' | dealLanguage('Please enter your email address')"></Input>
            </FormItem>
          </Form>
          <Form :label-width="74" label-position="left" v-show="orderItem.invoiceStatus != 0">
            <FormItem :label="'发票金额' | dealLanguage('Amount')" class="lh30 lh30-1">
              <span>¥{{orderItem.paymentAmount}}</span>
            </FormItem>
            <FormItem :label="'发票类型' | dealLanguage('Invoice Type')" class="lh30 lh30-1">
              <span>{{'增值税电子普通发票' | dealLanguage('VAT electronic general invoice')}}</span>
            </FormItem>
            <FormItem :label="'抬头类型' | dealLanguage('Header Type')" class="lh30 lh30-1">
              <span v-if="language == 'zh'">{{orderItem.headerType == 1 ? '个人' : '单位'}}</span>
              <span v-if="language == 'en'">{{orderItem.headerType == 1 ? 'personal' : 'company'}}</span>
            </FormItem>
            <FormItem :label="'发票抬头' | dealLanguage('Invoice Title')" class="lh30 lh30-1">
              <span>{{orderItem.header}}</span>
            </FormItem>
            <FormItem :label="'单位税号' | dealLanguage('Unit tax number')" class="lh30 lh30-1" v-if="orderItem.headerType == 2 && orderItem.uniformSocialCreditCode">
              <span>{{orderItem.uniformSocialCreditCode}}</span>
            </FormItem>
            <FormItem :label="'电子邮箱' | dealLanguage('Email')" class="lh30 lh30-1">
              <span>{{orderItem.email}}</span>
            </FormItem>
            <FormItem :label="'发票状态' | dealLanguage('Invoice Status')" class="lh30 lh30-1">
              <span v-if="language == 'zh'">{{orderItem.invoiceStatus == 1 ? '开票中' : '已开票'}}</span>
              <span v-if="language == 'en'">{{orderItem.invoiceStatus == 1 ? 'Invoicing' : 'Invoiced'}}</span>
            </FormItem>
          </Form>
        </div>
        <div class="container-bottom">
          <div class="tip tip2" v-if="orderItem.invoiceStatus == 0">
            {{'我们将通过电子邮箱向您发送电子版发票，发票信息一经提交，无法修改，请谨慎填写' | dealLanguage('We will send you an electronic invoice via email. Once the invoice information is submitted, it cannot be modified. Please fill it in carefully.')}}
          </div>
          <div class="tip tip2" v-else>
            {{'我们将通过电子邮箱向您发送电子版发票' | dealLanguage('We will send you an electronic invoice via email')}}
          </div>
          <div class="btns-wrapper"  v-if="orderItem.invoiceStatus == 0">
            <Button class="close-btn" type="primary" @click="close">{{'取消' | dealLanguage('Cancel')}}</Button>
            <Button class="submit-btn" :loading="buttonLoading" type="primary" @click="applyInvoice">{{'提交' | dealLanguage('Submit')}}</Button>
          </div>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
import {
  addinvoice,
} from '@/service/vbef'
import filter from 'js/filter'
import { mapState } from 'vuex'
export default {
  data() {
    return {
      filter,
      orderItem: {},
      orderIndex: 0,
      modelIndex: false,
      buttonLoading: false,
      invoiceForm: {
        header: '',
        headerType: 1,
        type: 1,
        uniformSocialCreditCode: '',
        email: '',
      },
      ruleValidate: {
        header: [{ required: true, message: filter.dealLanguage('请输入发票抬头', 'Please enter the invoice title'), trigger: 'blur' }],
        email: [
          { required: true, message: filter.dealLanguage('请输入电子邮箱', 'Please enter your email address'), trigger: 'blur' },
          { type: 'email', message: filter.dealLanguage('请填写正确的邮箱', 'Please fill in the correct email address'), trigger: 'blur' },
        ],
      },
    }
  },
  computed: {
    ...mapState({
      static_img_url: (state) => state.static_img_url,
      index2_path: (state) => state.index2_path,
      index_path: (state) => state.index_path,
      language: (state) => state.language,
    }),
  },
  methods: {
    close() {
      this.modelIndex = false
    },
    clearForms(value) {
      if (value) return
      this.$refs['apply-invoice'].resetFields()
    },
    applyInvoice() {
      this.$refs['apply-invoice'].validate(async (valid) => {
        if (valid) {
          this.buttonLoading = true
          this.invoiceForm.orderId = this.orderItem.id
          let res = await addinvoice(this.invoiceForm)
          this.buttonLoading = false
          if (res.code == 0) {
            this.$Message.success(this.language == 'zh' ? '申请成功！' : 'Application successful!')
            this.$emit('success', res.data, this.orderIndex)
            this.modelIndex = false
          } else {
            this.$Message.error(filter.dealLanguage(res.msg, res.enMsg || res.msg))
          }
        }
      })
    },
  },
  created() {},
  mounted() {},
}
</script>

<style lang="stylus" scoped>
@import '~styles/login.styl'
@import '~styles/modal-form-pc.styl'
</style>
